import { Injectable } from '@angular/core';
import { CanvasSnapshot } from './canvas.models';

@Injectable({ providedIn: 'root' })
export class CanvasStorageService {
  read(storageKey: string): CanvasSnapshot | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    const raw = localStorage.getItem(storageKey);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as CanvasSnapshot;
    } catch {
      return null;
    }
  }

  write(storageKey: string, snapshot: CanvasSnapshot): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.setItem(storageKey, JSON.stringify(snapshot));
  }

  remove(storageKey: string): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.removeItem(storageKey);
  }
}
